import bingAds from '@/assets/svgs/icons/bing-ads.svg';
import googleAds from '@/assets/svgs/icons/google-ads.svg';
import linkedinAds from '@/assets/svgs/icons/linkedin-ads.svg';
import metaAds from '@/assets/svgs/icons/meta-ads.svg';
import taboolaAds from '@/assets/svgs/icons/taboola-ads.svg';
import tiktokAds from '@/assets/svgs/icons/tiktok-ads.svg';
import { CampaignProvider } from '@superfunnel/types';

const adsPlatformIcons: Record<CampaignProvider, string> = {
  google: googleAds,
  facebook: metaAds,
  bing: bingAds,
  linkedin: linkedinAds,
  taboola: taboolaAds,
  tiktok: tiktokAds,
};

export const getAdsPlatformIcon = (platform: CampaignProvider): string => {
  return adsPlatformIcons[platform];
};

export const assetUrlToCDNUrl = (assetUrl?: string) => {
  if (!assetUrl) {
    return assetUrl;
  }

  if (
    assetUrl.startsWith(
      'https://firebasestorage.googleapis.com/v0/b/cyder-ai.appspot.com/o/',
    )
  ) {
    const url = new URL(
      assetUrl.replace(
        'https://firebasestorage.googleapis.com/v0/b/cyder-ai.appspot.com/o/',
        'https://cdn.superfunnel.ai/',
      ),
    );
    const path = decodeURIComponent(url.pathname);
    return `https://cdn.superfunnel.ai${path}`;
  }

  if (
    assetUrl.startsWith(
      'https://firebasestorage.googleapis.com/v0/b/ai-marketing-agents-406e0.firebasestorage.app/o/',
    )
  ) {
    const url = new URL(
      assetUrl.replace(
        'https://firebasestorage.googleapis.com/v0/b/ai-marketing-agents-406e0.firebasestorage.app/o/',
        'https://cdn.superfunnel.ai/',
      ),
    );
    const path = decodeURIComponent(url.pathname);
    return `https://cdn.superfunnel.ai${path}`;
  }

  return assetUrl;
};
